<div class="modal fade" id="digioModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header">
        <h5>Digio DigiLocker Verification</h5>
        <button class="close" (click)="closeDigioModal()">×</button>
      </div>

      <div class="modal-body text-center">

        <div *ngIf="showSpinner">
          Processing...
        </div>

        <button
          class="btn btn-primary"
          (click)="DigioCreateRequest(customerPhone)"
        >
          Start DigiLocker Verification
        </button>

      </div>

    </div>
  </div>
</div>